import { test } from 'ramda';

import { APPLICATION_PATHS, SECTIONS_PATHS } from '@framework/constants/enums';
import getCanAccessBasedOnRoomPermissions from '@framework/guards/modules/common/activeRoomPermissionsGuard';
import { type RouteHandler } from '@framework/guards/type';

import { PERMISSIONS } from '@type/permissions';

export const meetingsPermissionsGuard = [
    PERMISSIONS.CAN_CREATE_MEETINGS,
    PERMISSIONS.CAN_UPDATE_MEETINGS
];

export const meetingsGuard: RouteHandler<[], boolean> = {
    test: test(
        new RegExp(
            `/${APPLICATION_PATHS.ADMINISTRATOR}/${APPLICATION_PATHS.ROOMS}/([^/]+)/${SECTIONS_PATHS.MEETINGS}/`
        )
    ),
    handler: async (_ctx, contextMethods) => {
        const { call } = contextMethods;

        const canAccess = await call(getCanAccessBasedOnRoomPermissions, meetingsPermissionsGuard);
        return canAccess;
    }
};
